const en = {
  'banner.introduction':
    'The leading provider of engaging mobile talent management solutions',
  'banner.introduction.covid': ' ',
  'banner.introduction.post-covid': '',
  'featureList.onboarding': 'Employee Onboarding Plan',
  'featureList.onboarding.content':
    'A phased and easy to access onboarding process that lets newcomers become familiar with the company and its basic operation process rapidly.',
  'featureList.structuredTraining': 'Structured Training',
  'featureList.structuredTraining.content':
    'Blended learning that seamlessly integrates digital, workshop/classroom, and live experiences into purpose-driven learning journeys.',
  'featureList.behaviorRecongnition': 'Behavior Recognition',
  'featureList.behaviorRecongnition.content':
    'Positive, real-time, and frequent feedback with gamification interactions to create a collaborative and productive atmosphere around the workplace.',
  'featureList.personalDevelopment': 'Personal Development',
  'featureList.personalDevelopment.content':
    'Tailor-made individual development and coaching that help employees to identify areas of improvement.',
  'featureList.organizationalCommunication': 'Organizational Communication',
  'featureList.organizationalCommunication.content':
    'Announcements, Employee Feedback, Survey, and Messaging capabilities grouped by departments support a two-way channel to enhance communication efficiency.',
  'featureList.realtimePerformanceTracking': 'Real-time Performance Tracking',
  'featureList.realtimePerformanceTracking.content':
    'Real-time monitoring of key performance indicators notifies managers of their subordinates’ performance.',
  'featureList.companySuccessionPlanning': 'Company Succession Planning',
  'featureList.companySuccessionPlanning.content':
    'An effective tool that helps companies to identify gaps in their organization through long-term employees’ overall performance monitoring.',
  copyRight: 'Copyright @ 2020 AMPOS Solutions Inc. All Rights Reserved',
  'product.title': 'Product',
  'product.introduction':
    "To deal with the fast-changing and unexpected challenges of a dynamic working environment, AMPOS provides an engaging, scalable, and sustainable mobile people and organizational culture development solution. AMPOS enables organizations to achieve business results through its feature-rich modules that together drive changes in employees' behaviors.",
  'product.download': 'Download the app',
  'product.store.ios': 'App Store',
  'product.store.google': 'Google Play',
  'product.store.360': '360',
  'product.store.tencent': 'Tencent',
  'product.store.baidu': 'Baidu',
  'product.store.huawei': 'Huawei',
  'product.store.oppo': 'OPPO',
  'product.store.xiaomi': 'Xiaomi',
  'product.store.flyme': 'Flyme',
  'product.store.wandoujia': 'Wandoujia',
  'service.intro.title': 'Services',
  'service.intro.subtitle': 'Consulting and Project Services',
  'service.intro.content1': `AMPOS\' multinational team with extensive experience delivering cloud-based enterprise software solutions on Amazon Web Services (AWS) to some of the world\'s largest companies. We recruited experienced product managers, engineers, and solution delivery experts from leading global technology companies.
    \nAMPOS provides consulting and project-based services to companies in need of leveraging the AMPOS team\'s deep expertise in SaaS enterprise software development and AWS services.
    \nHear from our CTO and Chief Architect on how we manage our solution architecture across AWS global and China regions.`,
  'service.content.title': 'Our services include',
  'service.content.list1':
    'Software as a Service software development, including mobile application and web application',
  'service.content.list2':
    'Software as a Service software architecture consulting services ',
  'service.content.list3': 'Cloud migration consulting services',
  'service.content.content':
    'Our dedicated Services teams are based in Bangkok and Taipei with specialties in Agile/Scrum Project management, Software architecture, Business analytics, UX/UI Design, Kotlin, Java, iOS, NodeJS, Python, Android, Angular, AWS, ReactJS, Flutter. \n\nWe have hands-on in-depth knowledge in AWS ElastiCache, SNS, SQS, CloudFront, Lambda, ELB, EC2, ECS, Elastic Beanstalk, DynamoDB, RDS, S3, CloudFormation, Route53.',
  'contact.phone': 'O. ',
  'contact.taipeiCompanyName': 'AMPOS Solution Inc.',
  'contact.taipeiAddress': '6F, No. 141, Sec. 3, Renai Rd., Taipei, Taiwan 106',
  'contact.chinaCompanyName': 'AMPOS China',
  'contact.chinaAddress':
    '4F, No. 89, Taixing Rd., Jingan, Shanghai, China 200041',
  'contact.bangkokCompanyName': 'AMPOS Solutions (Thailand) Co., Ltd.',
  'contact.bangkokAddress':
    '699 Modernform Tower, 22nd Floor, Unit No. 2204 Srinakarindr Road, Phatthanakan,  Suanluang,  Bangkok  10250',
  'contact.form.title': 'Get in Touch',
  'contact.form.name': 'Name',
  'contact.form.email': 'Email',
  'contact.form.phone': 'Phone',
  'contact.form.comment': 'Comment',
  'contact.form.submit': 'Send Message',
  'contact.form.validation.required': 'Required',
  'contact.form.validation.invalid.email': 'Invalid email address',
  'contact.form.validation.invalid.phone': 'Phone number is not valid',
  'about.header': 'ABOUT',
  'about.main.content':
    "We are AMPOS, a company where innovation knows no limit. We specialize in technology that makes HR stay on top of Talent Management trends. Looking for cost reduction, operational performance improvement, talent search and development, and intelligent management? Our Talent Management solution can be deployed quickly for a large user base. Need help with people's challenges?   Our professional team can offer you effective tailored solutions to address your needs. \n\nWe have successfully assisted manufacturing, restaurant, retail, and many other industries to enhance human resources management/development. We are an international company with offices in Bangkok, Shanghai, and Taipei to provide fully regional support and product development knowledge.",
  'about.team.title': 'OUR TEAM',
  'about.team.introduction':
    "We are a no nonsense fast-moving team with extensive software development and management experience at Amazon, IBM, Intel, MicroStrategy, PayPal, PwC, Thomson Reuters, Trend Micro, Harvard Business School, Carnegie Mellon University and Chulalongkorn's Sasin Business School, as well as strong financial support from strategic investors, we are looking for people who are hungry and passionate to make a difference and grow with our company.",
  'about.press.header': 'AMPOS in the Press',
  'career.header.title': 'Career',
  'career.benefit.title': 'BENEFIT',
  'career.benefit.performance':
    'Performance-based bonus every 6 months (i.e. twice per year)',
  'career.benefit.working_hours': 'Flexible working hours',
  'career.benefit.vacation':
    'Ten (10) paid vacation days, with a 2-day increment each year, up to a maximum of 20 days total',
  'career.benefit.snacks': 'Free drinks and snacks',
  'career.benefit.shirts': 'Free team polo shirts in different colors',
  'career.benefit.environment':
    'Relaxed working environment (e.g. Xbox 360, PS3, and ping pong table)',
  'career.benefit.activities': 'Team outings and teamwork activities',
  'career.benefit.training': 'Developer, IT, creative/design training program',
  'career.benefit.work_overseas':
    'Opportunity to work in foreign countries (some positions only)',
  'career.benefit.marketing':
    'Opportunity to participate in offline marketing events with compensation of 2,000 THB per day',
  'career.benefit.referral':
    'Employee referral program of 20,000 THB per successful referral, for both Introducer and referrals',
  'career.benefit.health_insurance':
    'Group health insurance and social security',
  'header.home': 'Home',
  'header.product': 'Product',
  'header.solution': 'Solution',
  'header.service': 'Service',
  'header.about': 'About',
  'header.career': 'Careers',
  'header.contact': 'Contact',
  'header.language': 'Language',
  'header.download': 'Download',
  'email.successMsg': 'We already received your comment',
  'email.errorMsg': 'Something wrong. Please try again later',
  'link.download.ampos': 'AMPOS is available to download now at',
  'link.download.pacd': 'PacD is available to download now at',
  faq: ' ',
};
export default en;
